import PhoneNumberInput from '@components/shared/PhoneNumberInput';
import StepLayout from '@features/DocViewer/Steps/StepLayout';
import useOnEnterKeyPress from '@shared/hooks/useOnEnterKeyPress';
import PropTypes from 'prop-types';

import { DOC_VIEWER_STEPS } from '@shared/constants';
import { useFormContext } from 'react-hook-form';

import useSendOtp from '@hooks/useSendOtp';
import styles from './EnterMobileAndEmail.module.scss';

const EnterMobileAndEmail = ({ currentStep, setCurrentStep }) => {
  const {
    handleSubmit,
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  const { mutateAsync: sendOtp, isLoading } = useSendOtp(
    {
      onSuccess: () => {
        setCurrentStep(DOC_VIEWER_STEPS.verify);
      },
      onError: err => console.error({ error: JSON.stringify(err) }),
    },
    true,
  );

  const onSubmit = async () => {
    sendOtp({
      phone: getValues('phone'),
    });
  };

  useOnEnterKeyPress(handleSubmit(onSubmit), isLoading);

  return (
    <StepLayout
      title={currentStep.title}
      info='Enter your mobile number to get one-time password (OTP)'
      primaryButtonText='Send OTP'
      primaryButtonOnClick={handleSubmit(onSubmit)}
      primaryButtonDisabled={isLoading}
      primaryButtonStyle={styles.button}
    >
      <div className={styles.form}>
        <PhoneNumberInput
          control={control}
          defaultValue='+1'
          error={errors.phone}
          autofocus
        />
      </div>
    </StepLayout>
  );
};

EnterMobileAndEmail.propTypes = {
  currentStep: PropTypes.shape({
    title: PropTypes.string,
    mobileTitle: PropTypes.string,
    id: PropTypes.number,
    step: PropTypes.number,
  }),
  setCurrentStep: PropTypes.func,
};

export default EnterMobileAndEmail;
